import React from 'react';
import './login.css'
import CTA from '../component/common/cta';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import pic1 from '../assets/pic1.png'
import './no-access.css'

const Noaccess = () => {



    return ( 
        <>
        <section className='sec1'>

            <article className='no-accesscard-container'>

                <article className='form'>
                    <img src={pic1} alt='logo'></img>
                    <h1 className='header-loginn'>Access Denied</h1>

                    <p className='para-login'>
                        You don't have permission to access Dashboard.
                    Only Admins have the access.
                    </p>

                    <CTA title='Return Back' to='/'/>
                     

                </article>

                <h3 className='copyrights'>© 2026 Workspace Exhibition. All rights reserved.</h3>
        </article>
        </section>
        </>
     );
}
 
export default Noaccess;